import { apiFetch } from '../../apiFetch'

export const assignRole = async (payload) => {
  return await apiFetch({
    method: 'PUT',
    path: `/admin/roles/${payload.role_slug}/users/${payload.user_slug}`,
    payload
  })
}
